import { useSelector } from 'react-redux';
import Helmet from '@plone/volto/helpers/Helmet/Helmet';
import config from '@plone/volto/registry';

const OEmbedHead = () => {
  const content = useSelector((state) => state.content.data);

  if (!content || content['@type'] !== 'media_page') return null;

  const uid = content.UID;
  if (!uid) return null;

  const siteUrl = config.settings.publicURL || '';
  const oembedUrl = `${siteUrl}/oembed?url=${encodeURIComponent(
    `${siteUrl}/resolveuid/${uid}`,
  )}&format=json`;

  return (
    <Helmet>
      <link
        rel="alternate"
        type="application/json+oembed"
        href={oembedUrl}
        title={content.title || ''}
      />
    </Helmet>
  );
};

export default OEmbedHead;
